import { Dropdown } from 'primereact/dropdown';
import { useTranslation } from 'react-i18next';

import { IViewOption as ViewOption } from '../utils/types';

export function ViewSwitcher({
  currentView,
  onViewChange,
  disabled = false,
  className,
}: {
  currentView: 'donor' | 'donor-schedule';
  onViewChange: (view: 'donor' | 'donor-schedule') => void;
  disabled?: boolean;
  className?: string;
}) {
  const { t } = useTranslation();

  const viewOptions: ViewOption[] = [
    {
      label: t('bulkDonorScheduling.Donor_Rows'),
      value: 'donor',
    },
    {
      label: t('bulkDonorScheduling.Donor_Schedule_Rows'),
      value: 'donor-schedule',
    },
  ];

  return (
    <Dropdown
      value={currentView}
      options={viewOptions}
      onChange={(e) => onViewChange(e.value)}
      disabled={disabled}
      className={className}
      placeholder={t('bulkDonorScheduling.Select_View')}
    />
  );
}
